import { showModal } from "../../common/constants/functions/modalFunctions";
import { formState } from "../form/FormState";
// Variables that allow the display of the form when the user has not registered his data.
let openedFromBack = false;
export function showAlert(fromBack = false) {
    openedFromBack = fromBack;
    if (document.getElementById('popupTypology')) {
        showModal('popupTypology');
    }
    window.sessionStorage.setItem("modalShown", "true");
}
function blockLink(e, target) {
    e.preventDefault();
    formState.manageState('pendingLink', target.href);
    showAlert();
}
export function loadPopupTypology() {
    document.addEventListener("click", (e) => {
        const target = e.target.closest("a");
        if (target instanceof HTMLAnchorElement) {
            const submenuLink = target.classList.contains("content-items-menu__subitems__info");
            const tabNavigationLink = target.classList.contains("ev-tabs-column__item");
            const otherAreasBlueprintsLink = target.classList.contains("js-blueprint-modal");
            const otherAreasRedirectLink = target.classList.contains("js-blueprint-modal-redirect");
            let nextTarget = target.href.split('/');
            const baseUrl = `${window.location.protocol}//${window.location.host}/`;
            const redirectLink = target.href !== baseUrl;
            const enableLinks = [
                'proyectos-vivienda', 'apartamentos', 'apartaestudios', 'casas',
                'proyectos-vacacionales', 'vivienda-interes-social', 'lotes',
                'outlet-inmobiliario', 'dataliving', 'user',
                'https://grupo.estrenarvivienda.com/login'
            ];
            const enableLink = enableLinks.find((sublink) => sublink === nextTarget[3]);
            const allowRedirect = submenuLink ? true : (!enableLink ? true : false);
            const popupFormCompleted = window.sessionStorage.getItem("popupFormSent") === "true";
            const contactFormSent = window.sessionStorage.getItem("contactFormSent") === "true";
            const modalShown = window.sessionStorage.getItem("modalShown") === "true";
            const showPopup = window.sessionStorage.getItem("showPopup") === "true";
            if ((redirectLink || allowRedirect) && !popupFormCompleted && !contactFormSent && !modalShown && showPopup && !tabNavigationLink && !otherAreasBlueprintsLink && !otherAreasRedirectLink) {
                blockLink(e, target);
                formState.manageState('formName', '#popupTypology');
            }
        }
    });
    // Simulation of the hidden modal Bootstrap event
    const popupTypology = document.getElementById('popupTypology');
    if (popupTypology) {
        popupTypology.addEventListener('hidden.bs.modal', () => {
            window.sessionStorage.setItem("modalShown", "false");
            if (formState.manageState('pendingLink')) {
                const linkToGo = formState.manageState('pendingLink');
                formState.manageState('pendingLink', null);
                window.location.href = linkToGo;
                formState.manageState('formName', '#typologyForm');
            }
        });
    }
}
